module.exports = __webpack_public_path__ + "static/media/clutchLogin.a38ebad1.webp";